import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaCheck, FaTimes } from "react-icons/fa";

const BRAND_GRADIENT = "linear-gradient(135deg, #5f2eea, #0a84ff)";
const BASE_URL = "http://165.22.218.70:1112";

/* ================= WRAPPER ================= */

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 40px 30px;
  font-family: "Poppins", sans-serif;
  color: #fff;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
  background: ${BRAND_GRADIENT};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

/* ================= TABLE ================= */

const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 16px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: rgba(255,255,255,0.08);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  overflow: hidden;
`;

const Thead = styled.thead`
  background: ${BRAND_GRADIENT};
`;

const Th = styled.th`
  padding: 16px;
  text-align: left;
  font-size: 0.9rem;
`;

const Tr = styled.tr`
  border-bottom: 1px solid rgba(255,255,255,0.15);
  transition: 0.2s;

  &:hover {
    background: rgba(255,255,255,0.08);
  }
`;

const Td = styled.td`
  padding: 14px;
  font-size: 0.85rem;
`;

const StatusBadge = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;

  background: ${({ status }) =>
    status === "APPROVED"
      ? "#16a34a"
      : status === "REJECTED"
      ? "#dc2626"
      : "#f59e0b"};
`;

/* ================= ACTION BUTTONS ================= */

const ActionBtn = styled.button`
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  margin-right: 8px;
  cursor: pointer;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${({ type }) =>
    type === "approve"
      ? "linear-gradient(135deg,#22c55e,#16a34a)"
      : "linear-gradient(135deg,#ef4444,#dc2626)"};
  color: #fff;
`;

/* ================= COMPONENT ================= */

export default function LeaveRequests() {

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH ALL LEAVE REQUESTS ================= */

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      const res = await fetch(`${BASE_URL}/webapp/leave`);
      const data = await res.json();
      setRequests(data);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= UPDATE STATUS ================= */

  const updateStatus = async (id, newStatus) => {
    try {
      const res = await fetch(
        `${BASE_URL}/webapp/leave/${id}/status?status=${newStatus}`,
        { method: "PUT" }
      );

      if (!res.ok) {
        throw new Error("Failed to update status");
      }

      // Refresh from backend (safer than manual update)
      fetchLeaves();

    } catch (error) {
      console.error("Error updating leave status:", error);
      alert("Failed to update leave status.");
    }
  };

  return (
    <Wrapper>
      <Title>Leave Requests Management</Title>

      <TableWrapper>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <Table>
            <Thead>
              <tr>
                <Th>Employee</Th>
                <Th>From</Th>
                <Th>To</Th>
                <Th>Reason</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </tr>
            </Thead>

            <tbody>
              {requests.length === 0 ? (
                <tr>
                  <Td colSpan="6">No leave requests found.</Td>
                </tr>
              ) : (
                requests.map((req) => (
                  <Tr key={req.id}>
                    <Td>{req.user?.name}</Td>
                    <Td>{req.startDate}</Td>
                    <Td>{req.endDate}</Td>
                    <Td>{req.reason}</Td>
                    <Td>
                      <StatusBadge status={req.status}>
                        {req.status}
                      </StatusBadge>
                    </Td>
                    <Td>
                      {req.status === "PENDING" && (
                        <>
                          <ActionBtn
                            type="approve"
                            onClick={() =>
                              updateStatus(req.id, "APPROVED")
                            }
                          >
                            <FaCheck /> Approve
                          </ActionBtn>

                          <ActionBtn
                            type="reject"
                            onClick={() =>
                              updateStatus(req.id, "REJECTED")
                            }
                          >
                            <FaTimes /> Reject
                          </ActionBtn>
                        </>
                      )}
                    </Td>
                  </Tr>
                ))
              )}
            </tbody>
          </Table>
        )}
        
      </TableWrapper>
    </Wrapper>
  );
}